import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendGeneratedTemplateDescription,
  BackendMutationGenerateTemplateDescriptionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation GenerateTemplateDescription($customerId: ID!, $exampleHtml: String!) {
    generateTemplateDescription(customerId: $customerId, exampleHtml: $exampleHtml) {
      description
    }
  }
`;

type Variables = BackendMutationGenerateTemplateDescriptionArgs;
type Result = BackendGeneratedTemplateDescription;

export const generateTemplateDescription = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
